module.exports = __webpack_public_path__ + "72bf0cb74adfd0fae6616d519923ae00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/g/g07.jpg
// module id = 569
// module chunks = 0